var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sk-checkbox',{staticClass:"terms-check",attrs:{"preselected-value":_vm.preselectedValue,"validation-name":_vm.validationName,"item-text":_vm.termsText},on:{"checkboxvaluechanged":_vm.catchValueChange}})}
var staticRenderFns = []

export { render, staticRenderFns }